import React, { useState, useEffect } from 'react';
import uid from 'harsh-uid';

import pick2 from '../../Assets/Icons/pick_2.png';
    

const MediaPicker = ({ classsName, type = 'image', source, onChange, multiple, text, Delete, onDelete }) => {
     
  
    const id = uid();

    const [err, setErr] = useState(null);

    return (
    
    <div className='media-picker card'>
        <input
            type='file'
            style={{ display: 'none' }}
            id={id}
            accept={type === 'image' ? 'image/*' : type === 'video' ? 'video/*' : 'image/*,  video/*'}
            onChange={(file) => {
                const _type = file.currentTarget.files[0].type.split('/')[0];
                if (type === 'media') {
                    if (_type === 'image' || _type === 'video') {
                        onChange(file.currentTarget.files[0], URL.createObjectURL(file.currentTarget.files[0]));
                        setErr(null);
                    } else {
                        setErr('file is not image or video');
                    }
                } else if (type === 'image') {
                    if (_type === 'image') {
                        onChange(file.currentTarget.files[0], URL.createObjectURL(file.currentTarget.files[0]));
                        setErr(null);
                    } else {
                        setErr('file is not image');
                    }
                } else if (type === 'video') {
                    if (_type === 'video') {
                        onChange(file.currentTarget.files[0], URL.createObjectURL(file.currentTarget.files[0]));
                        setErr(null);
                    } else {
                        setErr('file is not video');
                    }
                }
            }}
            multiple={multiple}
        />
        <label htmlFor={id} className={classsName}>
            {
                type === 'image' || !source ? (
                    <img src={!source ? pick2 : source} className={!source ? 'opacity' : null} style={{width:"150px", height:'150px'}} />
                ) : (
                    <video controls>
                        <source src={source} />
                    </video>
                )
            }
            {text && (<span style={{display:'block',fontSize:'14px', background:'#666', color:'#f3f3f3', padding:'2px 0', textAlign:'center', width:'150px'}}>{text}</span>)}
        </label>
        {Delete && (
            <button className='btn' onClick={onDelete}>Remove</button>
        )}
        {err && (<div className='err'>{err}</div>)}
    </div>);
}

export default MediaPicker;